<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="11">
    </PogressBarStep>
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content2']">
          <div :class="[deviceType, 'frame-grey']">
            <div class="remark">
              {{ t("ccOnBoarding.uploadDocument.remark1") }}
              <br />
              {{ t("ccOnBoarding.uploadDocument.remark2") }}
            </div>
          </div>

          <div class="line">
            <div :class="[deviceType, 'separator']">
              <div class="container2">
                <p class="title">
                  {{ t("ccOnBoarding.uploadDocument.proofIdentity") }}
                </p>
                <div>
                  <p class="remarkHeader">
                    {{ t("ccOnBoarding.uploadDocument.upload") }}
                  </p>
                  <div
                    v-if="prop.ccForm.supplementary.idType == '0'"
                    class="remarkIncomeContainer"
                  >
                    <p class="remarkIncome">
                      {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark1") }}
                    </p>
                    <p class="remarkIncome">
                      {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark3") }}
                    </p>
                  </div>
                  <div v-else class="remarkIncomeContainer">
                    <p class="remarkIncome">
                      {{ t("ccOnBoarding.uploadDocument.proofIncomeRemark4") }}
                    </p>
                  </div>
                </div>
                <div class="uploadFile">
                  <UploadFile
                    :key="uploadFileKey"
                    :id="generateUploadFileId()"
                    @change="uploadFileQuestion1"
                    :file-holder="
                      prop.ccForm.supplementaryUploadDocument.proofIdentity.file
                    "
                    :file-holder-name="
                      prop.ccForm.supplementaryUploadDocument.proofIdentity
                        .fileName
                    "
                    :file-number="
                      prop.ccForm.supplementaryUploadDocument.proofIdentity
                        .fileNumber
                    "
                    field="upload1"
                    :uploadFileValidity="uploadFileValidity"
                    :errorDisabledSubmitButton="
                      prop.uploadFileValidity.uploadFile1 == 'EC001'
                    "
                  />
                  <pre class="help" v-if="fileSize">{{
                    t("ccOnBoarding.uploadDocument.fileError")
                  }}</pre>
                  <pre class="help" v-else-if="!upload1">{{
                    t("ccOnBoarding.uploadDocument.required")
                  }}</pre>
                  <pre class="help" v-if="encrypted">{{
                    t("ccOnBoarding.uploadDocument.encrypted")
                  }}</pre>
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'EC001'"
                    >{{
                      t("ccOnBoarding.uploadDocument.invalidFileConversion")
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'EC002'"
                    >{{
                      t("ccOnBoarding.uploadDocument.maliciousFileDetected", {
                        files: uploadFileValidity.maliciousFile1Names.join(", "),
                      })
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile1 == 'invalidFileType'"
                    >{{ t("ccOnBoarding.uploadDocument.invalidFileType") }}</pre
                  >

                  <div
                    v-if="
                      prop.ccForm.supplementaryUploadDocument.proofIdentity
                        .fileNumber != 0 && deviceType != 'Mobile'
                    "
                    style="margin-top: 20px"
                  >
                    <FileList
                      :question="
                        prop.ccForm.supplementaryUploadDocument.proofIdentity
                      "
                      :filePath="prop.ccForm.imageFilePath"
                      :isSupplementary="true"
                      :type="prop.type"
                      :webFormRequestId="prop.webFormRequestId"
                      :uploadFileValidity="uploadFileValidity"
                      :fileType="'identity'"
                    ></FileList>
                  </div>
                </div>
                <div
                  v-if="
                    prop.ccForm.supplementaryUploadDocument.proofIdentity
                      .fileNumber != 0 && deviceType == 'Mobile'
                  "
                  class="margin"
                >
                  <p class="uploaded">
                    {{ t("ccOnBoarding.uploadDocument.uploaded") }}
                  </p>
                  <FileList
                    :question="
                      prop.ccForm.supplementaryUploadDocument.proofIdentity
                    "
                    :filePath="prop.ccForm.imageFilePath"
                    :isSupplementary="true"
                    :type="prop.type"
                    :webFormRequestId="prop.webFormRequestId"
                    :uploadFileValidity="uploadFileValidity"
                    :fileType="'identity'"
                  ></FileList>
                </div>
              </div>
            </div>
          </div>

          <div :class="[deviceType, 'buttoncontainer']">
            <button
              v-if="prop.summarySetting.supplementaryUploadFileJump == false"
              :class="[deviceType, 'left-button']"
              type="button"
              @click="handleBack"
            >
              {{ t("ccOnBoarding.back") }}
            </button>
            <div v-else :class="[deviceType, 'left-button:disabled']"></div>
            <button
              v-if="prop.summarySetting.supplementaryUploadFileJump == false"
              :disabled="isBtnDisabled"
              :class="[deviceType, 'right-button']"
            >
              {{ t("ccOnBoarding.next") }}
            </button>
            <button
              v-else
              :class="[deviceType, 'summary-button']"
              :disabled="isBtnDisabled"
            >
              {{ t("ccOnBoarding.backToSummary") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
    <PopupMessage
      name="'none'"
      :type="'none'"
      :header="'uploadDocJump'"
      v-if="popup"
      @close-modal="closeTNCModal"
      @submit="submitTNCModal"
      :popup="true"
    >
    </PopupMessage>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, type PropType } from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import professional from "@/enum/Profesinol";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import Constants from "@/constants/constants";
import UploadFile from "./components/NewUploadFileComponent.vue";
import FileList from "./components/UploadedFileList.vue";
import type FormCC from "@/interface/FormCC";
import { pdfRequiresOpenPassword } from "@/utils/pdfRequiresOpenPassword";
import Swal from "sweetalert2";
import { deviceDetect } from "mobile-device-detect";
import Compressor from "compressorjs";
import type { SummarySetting } from "@/interface/FormCC";
import PopupMessage from "./components/PopupMessage.vue";
import heic2any from "heic2any";

const deviceType = ref("");

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const jump = () => {
  emit("jumpStep", "10", "", "10");
};

const prop = defineProps({
  ccForm: {
    type: Object as PropType<FormCC>,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  summarySetting: {
    type: Object as PropType<SummarySetting>,
    required: true,
  },
  uploadFileValidity: {
    type: Object,
    required: true,
  },
  webFormRequestId: {
    type: String,
  },
  type: {
    type: String,
  },
});

const errorMessage = ref("");
const error = ref(true);
const { t } = i18n.global;
const upload1 = ref(true);
const upload2 = ref(true);
const upload3 = ref(true);
const popup = ref(false);

const f = ref("Yes");

const ekyc = ref(false);
//List
const titleList = ref([] as string[]);
titleList.value = professional;

const schema = computed(() => {
  return {
    // supplementary: "required",
  };
});

const onInvalidSubmit = () => {
  errorMessage.value = t("ccOnBoarding.uploadDocument.required2");

  if (prop.ccForm.supplementaryUploadDocument.proofIdentity.fileNumber <= 0) {
    upload1.value = false;
  }
};

const emit = defineEmits(["nextStep", "previousStep", "jumpStep", "submit"]);

const onSubmit = () => {
  if (prop.ccForm.supplementaryUploadDocument.proofIdentity.fileNumber <= 0) {
    upload1.value = false;
  }

  if (!upload1.value || prop.uploadFileValidity.uploadFile1 == "EC001") {
  } else {
    if (prop.summarySetting.supplementaryCardDetailsJump == true) {
      popup.value = true;
    } else {
      emit("submit");
    }
  }
};

const handleBack = () => {
  emit("jumpStep", 9, "", 11);
};

//Proof of Indentity
const generateUploadFileId = () => {
  const fileNameLength =
    prop.ccForm.supplementaryUploadDocument.proofIdentity.fileName.length;
  return `uploadFileQuestion1N${fileNameLength}`;
};

const planNotEligible = Swal.mixin({
  title: "You are not eligible in this plan.",
  confirmButtonText: "Okay",
  customClass: {
    title: "sweetAlertTitle",
    confirmButton: "sweetAlertConfrimButton",
  },
});

const isBtnDisabled = computed(() => {
  return prop.ccForm.supplementaryUploadDocument.proofIdentity.fileNumber == 0;
});

const uploadFileKey = ref(0);
const fileSize = ref(false);
const encrypted = ref(false);

const uploadFileQuestion1 = async () => {
  fileSize.value = false;
  encrypted.value = false;
  const fileId = generateUploadFileId();
  const fileInput = (document.getElementById(fileId) as HTMLInputElement)
    .files?.[0];
  uploadFileKey.value += 1;

  if (fileInput != null) {
    const formData = new FormData();

    const maxSizeBytes = Constants.FILE_SIZE;

    if (fileInput.size > maxSizeBytes) {
      fileSize.value = true;
    } else {
      try {
        if (fileInput.name.toLowerCase().endsWith(".pdf")) {
          const buffer = await fileInput.arrayBuffer();
          if (await pdfRequiresOpenPassword(buffer)) {
            encrypted.value = true;
          } else {
            formData.append("file", fileInput);
            upload1.value = true;
            encrypted.value = false;
            prop.ccForm.supplementaryUploadDocument.proofIdentity.fileName.push(
              fileInput.name,
            );
            prop.ccForm.supplementaryUploadDocument.proofIdentity.fileNumber =
              prop.ccForm.supplementaryUploadDocument.proofIdentity.fileName.length;
            prop.ccForm.supplementaryUploadDocument.proofIdentity.file.push(
              formData,
            );
          }
        } else {
          //Compress the image
          // const compressedImage = await compressImage(fileInput);
          formData.append("file", fileInput as Blob, fileInput.name);

          // formData.append("file", fileInput);
          upload1.value = true;
          encrypted.value = false;
          prop.ccForm.supplementaryUploadDocument.proofIdentity.fileName.push(
            fileInput.name,
          );
          prop.ccForm.supplementaryUploadDocument.proofIdentity.fileNumber =
            prop.ccForm.supplementaryUploadDocument.proofIdentity.fileName.length;
          prop.ccForm.supplementaryUploadDocument.proofIdentity.file.push(
            formData,
          );
        }
      } catch {
        encrypted.value = false;
      }
    }
  }
};

const closeTNCModal = () => {
  popup.value = false;
};

const submitTNCModal = () => {
  emit("submit");
  popup.value = false;
};

// const compressImage = (file: File) => {
//   return new Promise((resolve, reject) => {
//     const fileExtension = file.name.split(".").pop()?.toLowerCase();
//     const allowedExtensions = ["heic", "heif"];
//     if (allowedExtensions.includes(fileExtension || "")) {
//       // Convert HEIC to JPEG first
//       heic2any({ blob: file })
//         .then((convertedFiles: Blob | Blob[]) => {
//           // Check if the result is an array or a single Blob
//           const convertedFile = Array.isArray(convertedFiles)
//             ? convertedFiles[0]
//             : convertedFiles;
//           new Compressor(convertedFile, {
//             quality: 0.5,
//             success(result) {
//               resolve(result);
//             },
//             error(err) {
//               reject(err);
//             },
//           });
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     } else {
//       new Compressor(file, {
//         quality: 0.5,
//         success(result) {
//           resolve(result);
//         },
//         error(err) {
//           reject(err);
//         },
//       });
//     }
//   });
// };
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.title {
  margin-bottom: 16px;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
  font: 500 20px/130% "Outfit";
  position: relative;
  align-self: stretch;
}
.remarkHeader {
  margin-bottom: 8px;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
  font: 500 16px/130% "Outfit";
  position: relative;
  align-self: stretch;
}

.remarkIncome {
  margin-bottom: 5px;
  text-align: left;
  color: rgba(0, 0, 0, 0.38);
  font: 500 14px/130% "Outfit";
  position: relative;
  align-self: stretch;
}

.remarkIncomeContainer {
  margin-bottom: 16px;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.content2 {
  margin-top: 40px;
  padding: 0 8%;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.separator {
  margin-bottom: 32px;
  margin-top: 32px;
  padding: 0 20px;
}

.separatorBottom {
  border-bottom: 1px solid #e4e4e4;
  margin-bottom: 20px;
  margin-top: 32px;
  padding: 0 20px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.summary-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
  transition: background-color 0.3s ease;
}

.summary-button:hover {
  background-image:
    linear-gradient(120deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:active {
  background-image:
    linear-gradient(120deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;

  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.brLine {
  margin-bottom: 18px;
  margin-top: 32px;
}

.frame-grey,
.frame-grey * {
  box-sizing: border-box;
}
.frame-grey {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 24px 32px 24px 32px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.remark {
  color: var(--web-black-medium, #757575);
  text-align: left;
  font-family: var(--subtitle-2-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-2-font-size, 14px);
  line-height: var(--subtitle-2-line-height, 130%);
  font-weight: var(--subtitle-2-font-weight, 500);
  position: relative;
  flex: 1;
}

.uploadFile {
  border-radius: 8px;
  border-style: solid;
  border-color: #e4e4e4;
  border-width: 1px;
  padding: 18px 24px;
  margin-top: 4px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet) {
    flex-direction: column;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .summary-button:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .summary-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 40px;
  }
}

.content:is(.Mobile),
.content2:is(.Mobile),
.separator:is(.Mobile),
.separatorBottom:is(.Mobile) {
  padding: 0;
}

.content2:is(.Mobile) {
  margin-top: 0px;
}

.separator .container {
  max-width: none;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.inner-last:is(.Mobile) {
  border-top: 1px solid #e4e4e4;
  padding: 0px 20px;
  border-bottom: 1px solid #e4e4e4;
}

.container:is(.Mobile),
.container2:is(.Mobile) {
  flex-direction: column;
}

.container3:is(.Mobile) {
  max-width: none !important;
}

.container4:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}

.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.flex_third:is(.Mobile) {
  width: 30%;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.summary-button:is(.Mobile) {
  flex: 0 0 100%;
}

.summary-button:disabled:is(.Mobile) {
  flex: 0 0 100%;
}

.frame-grey:is(.Mobile) {
  padding: 10px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.margin {
  margin-top: 20px;
}

.uploaded {
  margin-bottom: 15px;
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  text-align: left;
  font-family: var(--subtitle-1-medium-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-1-medium-font-size, 16px);
  line-height: var(--subtitle-1-medium-line-height, 130%);
  font-weight: var(--subtitle-1-medium-font-weight, 500);
  position: relative;
  flex: 1;
}
</style>
